import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Site } from './site.service';

@Injectable()
export class SensorTypeService {
  constructor(private httpClient: HttpClient) {}

  getSensorTypes(): Observable<SensorTypeDefinition[]> {
    return this.httpClient.get<SensorTypeDefinition[]>(environment.apiAddress + '/sensorType');
  }

  addSensorTypes(sensorTypeDefinitionParser: string, siteIds: string[]): Observable<any> {
    return this.httpClient.post<SensorTypeDefinition>(`${environment.apiAddress}/sensorType/`, {
      sensorTypeDefinitionParser: JSON.parse(sensorTypeDefinitionParser),
      siteIds: siteIds,
    });
  }

  updateAllowedSitesForSensorType(sensorTypeDefinitionId: string, siteIds: string[]): Observable<any> {
    return this.httpClient.put<SensorTypeDefinition>(
      `${environment.apiAddress}/sensorType/${sensorTypeDefinitionId}/sites`,
      { siteIds: siteIds }
    );
  }

  deleteSensorTypeDefinition(sensorTypeId: string): any {
    throw new Error('Method not implemented.');
  }
}

export interface SensorTypeDefinition {
  id: string;
  name: string;
  sensorTypeId: number;
  revision: number;
  description?: string | null;
  measurementDefinitions: string;
  statusMapping?: string | null;
  modbusDeviceType?: ModbusDeviceType | null;
  sourceJson?: string | null;
  siteIds: string[];
  sites: Site[];
}

export interface ModbusDeviceType {
  id: string;
  name: string;
  modbusType: string;
  typeId: number;
  revision: number;
}
